import { config } from '~/utils/constants';

/**
 * @param {number} idAssistServico Parâmetro recebido via query para conectar ao wss
 * @param {number} maxRetry Número máximo de re-tentativas de conexão
 */
function connect(idAssistServico, maxRetry = 1) {
  const ws = new WebSocket(`${config.BASEWS_URL}/${idAssistServico}`);

  ws.onclose = (_event) => {
    if (maxRetry > 1) {
      setTimeout(() => {
        connect(idAssistServico, maxRetry - 1);
      }, 1000);
    }
  };

  ws.onerror = (_err) => {
    ws.close();
  };

  return ws;
}

export default connect;
